var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100pct" },
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "item-list f-left w-100pct pd-vtc-10px al-center"
        },
        [
          _c("div", { staticClass: "w-15pct f-left" }, [
            _c("img", { attrs: { src: item.image, alt: "", width: "100%" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-85pct f-left t-al-left pd-l-10px" }, [
            _c("div", [
              _c("span", { staticClass: "f-s-16px f-w-bold" }, [
                _vm._v(_vm._s(item.name))
              ])
            ]),
            _vm._v(" "),
            _c("div", [_c("span", {}, [_vm._v(_vm._s(item.option))])]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "f-s-16px f-w-bold" }, [
                _vm._v(
                  " ฿ " +
                    _vm._s(_vm._f("showFullPriceFormat")(item.priceDiscount))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dp-flex jtf-ct-space-between" }, [
              _c(
                "div",
                { staticClass: "w-80pct" },
                [
                  item.priceDiscount != item.price
                    ? _c("strike", [
                        _vm._v(
                          "฿ " +
                            _vm._s(_vm._f("showFullPriceFormat")(item.price))
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "w-20pct" },
                [
                  _c("svg-filler", {
                    staticClass: "cs-pointer",
                    attrs: {
                      path: "/static/svg/trash-alt-regular.svg",
                      fill: "#000000",
                      width: "20px",
                      height: "20px"
                    },
                    on: {
                      click: function($event) {
                        _vm.confirmCustomDelete(item)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9a6ae3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9a6ae3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/ListCart.vue
// module id = 433
// module chunks = 1